export default {"src":"/_next/static/media/icon-user-plus.0949dbf2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};